export class HRAbility {
  id:                   string;
  hrConfigId:           string;
  ownerEmployeeId:      string;
  title:                string;
  description:          string;
  active=true;
}

